import { set } from 'lodash'

export default (settings: Record<string, any>) => {
  if (!settings.common) return
  const commonSettings = settings.common
  if (commonSettings['analytics-debug-tab'] !== undefined) {
    set(settings, ['analytics', 'debug-tab'], commonSettings['analytics-debug-tab'])
    delete commonSettings['analytics-debug-tab']
    settings.common = commonSettings
  }
}
